module.exports = __webpack_public_path__ + "43a969ae76b867469e2e25a93659ac86.svg";